import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	widgetsContainer: {
		width: "100%",
		height: "100%"
	},
	widgetsIframe: {
		width: "100%",
		height: "100%",
		border: "none"
	}
}))

export default useStyles
